import type { Task } from "@/hooks/useStudentDashboard";

interface TodayProgramProps {
  tasks: Task[];
  loading: boolean;
}

export default function TodayProgram({ tasks, loading }: TodayProgramProps) {
  const completed = tasks.filter((t) => t.completed).length;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 flex flex-col h-full">
      <div className="flex items-center justify-between px-5 py-4 border-b border-background-200">
        <div>
          <h2 className="font-heading font-semibold text-base text-foreground-950">Bugünkü Çalışma Programın</h2>
          <p className="text-xs text-foreground-500 mt-0.5">
            {loading ? "Yükleniyor..." : `${completed} / ${tasks.length} görev tamamlandı`}
          </p>
        </div>
      </div>

      <div className="p-4 space-y-3 flex-1">
        {loading ? (
          <div className="space-y-2">
            <div className="h-16 rounded-md bg-background-100 animate-pulse" />
            <div className="h-16 rounded-md bg-background-100 animate-pulse" />
          </div>
        ) : tasks.length === 0 ? (
          <div className="rounded-md bg-background-100 px-4 py-3">
            <p className="text-sm text-foreground-600">
              Bugün için planlanmış bir görev yok. Öğrenme rotan oluşturulduğunda günlük akışın burada görünecek.
            </p>
          </div>
        ) : (
          <ul className="space-y-1">
            {tasks.map((task) => (
              <li
                key={task.id}
                className="flex items-center gap-3 px-3 py-3 rounded-md bg-background-50 border border-background-100"
              >
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 shrink-0">
                  <i className={`${task.icon || "ri-checkbox-circle-line"} text-base`} aria-hidden="true"></i>
                </span>
                <div className="min-w-0 flex-1">
                  <p className={`text-sm font-medium ${task.completed ? "text-foreground-500 line-through" : "text-foreground-800"}`}>
                    {task.title}
                  </p>
                  {task.detail && (
                    <p className="text-xs text-foreground-500 truncate">{task.detail}</p>
                  )}
                </div>
                <span
                  className={`w-5 h-5 flex items-center justify-center rounded-full shrink-0 ${
                    task.completed ? "bg-accent-500 text-background-50" : "border border-background-300"
                  }`}
                >
                  {task.completed && <i className="ri-check-line text-xs" aria-hidden="true"></i>}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}